




import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import {
  Document,
  EditPhaseKinds,
} from "../../../../domain/document";
import { EditingDocument } from "..";
import { HisInformationApplicator } from "../helpers";

@Component
export default class DocumentPrinter extends Mixins() {
  @Prop()
  document: Document;

  public print(shouldSelectPrinter: boolean = false, shouldPrintDefaultCopies: boolean = false, shouldPrintWatermarkForcibly: boolean = false): void {
    if (!this.document) {
      return;
    }
    this.$logger.info("印刷を開始します。");
    this.printDocument(this.document.clone(), shouldSelectPrinter, shouldPrintDefaultCopies, shouldPrintWatermarkForcibly)
    .then(() => {
      this.$logger.info("印刷が完了しました。");
    }).catch(e => {
      this.$error("印刷エラー", "印刷処理中にエラーが発生しました。", e);
    });
  }

  /**
   * print()からprintAsync()をコールするように修正したほうがよいが、検証する余裕がないので未着手
   */
  public async printAsync(shouldSelectPrinter: boolean, shouldPrintDefaultCopies: boolean, shouldPrintWatermarkForcibly: boolean): Promise<void> {
    if (!this.document) {
      throw new Error("文書が格納されていないので印刷できません。");
    }
    this.$logger.info("印刷を開始します。");
    await this.printDocument(this.document.clone(), shouldSelectPrinter, shouldPrintDefaultCopies, shouldPrintWatermarkForcibly);
    this.$logger.info("印刷が完了しました。");
  }

  private async printDocument(source: Document, shouldSelectPrinter: boolean = false, shouldPrintDefaultCopies: boolean = false, shouldPrintWatermarkForcibly: boolean = false): Promise<void> {
    const hisApplicator = new HisInformationApplicator(new EditingDocument(source));
    hisApplicator.applyByProgress(
      source.hisInformation,
      EditPhaseKinds.Print,
      this.$store.getters.user,
      this.$store.getters.department,
      this.$store.getters.userAuthority.isOrderable ? this.$store.getters.user : source.attributes.orderUser,
      this.$store.getters.userAuthority.isOrderable ? this.$store.getters.user : source.attributes.attendingUser,
    );
    const repository = DomainRegistry.document.getDocumentRepository();
    const pdfSource = await repository.createPrintSource(source, false);
    const copies = shouldPrintDefaultCopies ? source.attributes.defaultCopies : 1;
    this.$printPdf(pdfSource.source, copies, shouldSelectPrinter, shouldPrintWatermarkForcibly);
  }
}
